import type { ReactNode } from "react";
import { Sidebar, type TSidebarProps } from "@/ui/organisms";
import { cn } from "@/utils/utils";

export interface TMainLayoutProps extends Omit<TSidebarProps, "className"> {
    children: ReactNode;
    className?: string;
}

export function MainLayout({
    children,
    userName,
    companyName,
    companyLogoUrl,
    isAdmin,
    isProdaUser,
    companyFeatureFlags,
    permissions,
    emulationTargets,
    subgroupLabels,
    effectiveSubgroup,
    userSubgroup,
    effectiveCompanyId,
    availableCompanies,
    onCompanySwitch,
    onSubgroupSwitch,
    onSettingsClick,
    onLogout,
    className,
}: TMainLayoutProps) {
    return (
        <div className="flex h-screen bg-background">
            <Sidebar
                userName={userName}
                companyName={companyName}
                companyLogoUrl={companyLogoUrl}
                isAdmin={isAdmin}
                isProdaUser={isProdaUser}
                companyFeatureFlags={companyFeatureFlags}
                permissions={permissions}
                emulationTargets={emulationTargets}
                subgroupLabels={subgroupLabels}
                effectiveSubgroup={effectiveSubgroup}
                userSubgroup={userSubgroup}
                effectiveCompanyId={effectiveCompanyId}
                availableCompanies={availableCompanies}
                onCompanySwitch={onCompanySwitch}
                onSubgroupSwitch={onSubgroupSwitch}
                onSettingsClick={onSettingsClick}
                onLogout={onLogout}
            />
            <main className={cn("flex flex-1 flex-col overflow-hidden min-w-0", className)}>
                {children}
            </main>
        </div>
    );
}
